// src/pages/sections/sections.js
import React from "react";
import Viewsection from "../../components/sections/viewsection";

export default function Sections() {
  return (
    // Page container with horizontal padding using Tailwind's "px-4" utility
    <div className="px-4">
       {/* Render the Viewsection component. This component likely handles displaying a list of HS Code sections or related data in a structured format (table, cards, etc.). */}
      <Viewsection />
    </div>
  );
}
